import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import Arrow from '../../assets/icons/arrow.svg'
import Search from '../../assets/icons/search.svg'
import HeaderSearchForm from './HeaderSearchForm'
import Button, { Variant } from '../Button/Button'
import Icon from '../Icon/Icon'

const StyledButton = styled(Button)`
  height: 100%;
  max-width: 8.75rem;
  padding: 1rem 0 1rem 1rem;
  font-weight: 400;
  font-size: 1.125rem;
  color: var(--dark);
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9999;
  svg {
    margin-right: 0;
  }

  &.close {
    left: -1rem;
    max-width: 2.5rem;
  }

  svg path {
    fill: var(--dark);
  }

  &:hover {
    background-color: inherit;
    color: var(--blue);
    svg path {
      fill: var(--blue);
    }
  }

  @media screen and (min-width: 48rem) {
    padding: 1rem 1rem 1rem 2rem;
  }
`

const MenuContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  margin-left: 0;
  z-index: 999;
`

interface HeaderSearchProps {
  isExpanded: boolean
  toggleMenu: () => void
  isMobile: boolean
}

const HeaderSearch: FunctionComponent<HeaderSearchProps> = ({
  isExpanded,
  toggleMenu,
  isMobile,
}) => {
  return (
    <MenuContainer>
      {isMobile ? (
        <>
          <StyledButton
            size={40}
            variant={Variant.Blank}
            className={isExpanded ? 'close' : 'search'}
            aria-label={isExpanded ? 'Close' : 'Search'}
            onClick={toggleMenu}
            id="search-mobile"
            data-testid="mobileSearchButton"
          >
            <Icon size={24}>{isExpanded ? <Arrow /> : <Search />}</Icon>
          </StyledButton>
          {isExpanded && (
            <HeaderSearchForm toggleMenu={toggleMenu} isMobile={isMobile} iconSize={24} />
          )}
        </>
      ) : (
        <HeaderSearchForm toggleMenu={toggleMenu} />
      )}
    </MenuContainer>
  )
}

export default HeaderSearch
